import CMSection from '@src/components/Atoms/CMSection';
import { devices } from '@src/styles/theme';
import Image from 'next/image';
import styled, { keyframes } from 'styled-components';

const First = () => {
  return (
    <CMSection>
      <Wrap>
        <FirstImage fill={true} src={'/imgs/sponser/first.svg'} alt="image" />
        <FirstImage_Mb
          fill={true}
          src={'/imgs/sponser/first-mb.svg'}
          alt="image"
        />
        <Text>
          지속해서 헌혈자는 줄고
          <br /> 환자는 늘어나고 있습니다
        </Text>
      </Wrap>
    </CMSection>
  );
};

const FirstImage = styled(Image)`
  object-fit: cover;
  display: block;

  @media ${devices.tablet} {
    display: none;
  }
`;
const FirstImage_Mb = styled(Image)`
  display: none;
  object-fit: cover;
  @media ${devices.tablet} {
    display: block;
    width: 100%;
    height: 100%;
  }
`;

const Wrap = styled.div`
  position: relative;
  height: 930px;
  @media ${devices.tablet} {
    height: 450px;
  }
`;

const KeyFrame = () => keyframes`
  0% {
    opacity: 0; /* 시작 시 투명도 1 (텍스트 보임) */
  }
  100% {
    opacity: 1; /* 끝날 때 투명도 0 (텍스트 사라짐) */
  }
`;

const Text = styled.div`
  color: #fff;
  text-align: center;
  font-family: 'NOTO';
  font-size: 47px;
  font-style: normal;
  font-weight: 600;
  line-height: 65px; /* 138.298% */
  letter-spacing: -1.41px;
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: ${KeyFrame} 2s ease-in-out;

  @media ${devices.tablet} {
    font-size: 18px;
    line-height: 36px; /* 150% */
    letter-spacing: -0.72px;
  }
`;

export default First;
